<template>
  <div>
    <template>
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">Appointment Details</h5>
        <button class="sa-btn-back" @click="$router.go(-1)">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-mob-cont">
        <ul class="sa-card-list-gray">
          <li>
            <div class="sa-card-list-box">
              <figure class="sa-avt-img">
                <img
                  v-if="d && d.img"
                  :src="d.img"
                  alt=""
                  class="sa-img-cover"
                />
                <img v-else :src="unknownImg" alt="" class="sa-img-cover" />
              </figure>
              <div class="sa-doct-det">
                <h6>{{ d.pname }}</h6>
                <h6></h6>
                {{ d.st_nm }}
              </div>
              <div class="sa-doct-apoint">
                Appointment ID : {{ d.apnt_id }}
                <span class="sa-doct-apoint-time">
                  {{ d.date }}
                  <dfn>{{ d.strt_tym }}</dfn>
                </span>
              </div>
            </div>
          </li>
          <li>
            <div class="sa-card sa-card-noshow">
              <div class="sa-row">
                <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                  <div class="sa-form-group">
                    <label>Service Type</label>
                    <span> {{ d.st_nm }}</span>
                  </div>
                </div>
                <!-- <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                  <div class="sa-form-group">
                    <label>Address </label>
                    <span>Gachbowli</span>
                  </div>
                </div>
                <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                  <div class="sa-form-group">
                    <label>Phone No </label>
                    <span>{{d.ph}}</span>
                  </div>
                </div> -->
              </div>
              <hr />
              <div
                v-if="d && d.tsk_nm && d.tsk_nm.length > 0"
                class="sa-mb20 sa-card"
              >
                <label class="sa-diagno-label">Selected Task</label>
                <span v-for="(n, i) in d.tsk_nm" :key="i">{{ n }}</span>
              </div>
              <div v-if="d && d.t_cmpd" class="sa-mb20 sa-card">
                <label class="sa-diagno-label"
                  >Task Completed <span class="sa-red-text">*</span></label
                >
                {{ d.t_cmpd }}
              </div>
              <div class="sa-mb20 sa-card">
                <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                  <label class="sa-diagno-label sa-mb10">Attachments</label>
                  <div
                    v-if="d && d.invsts"
                    class="sa-col-xs6 sa-col-sm8 sa-col-md8 sa-col-lg8 sa-mt20 sa-d-flex"
                  >
                    <a
                      target="_blank"
                      :href="d.invsts.url"
                      class="sa-avtar sa-avtar-exs"
                      v-for="(img, i) in d.invsts"
                      :key="i"
                    >
                      <img :src="img.url" class="sa-img-cover" />
                    </a>
                  </div>
                  <span v-else>No Attachments</span>
                </div>
              </div>
              <!-- <div class="sa-mb20 sa-card">
                <input type="checkbox" id="checkbox" v-model="checked" />
                <label for="checkbox"> Sign in & complete</label>
              </div> -->
            </div>
            <!-- <div class="sa-text-right">
              <button
                class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs">
                Save
              </button>
            </div> -->
          </li>
        </ul>
      </div>
    </template>
    <div v-if="loading">
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  </div>
</template>
<script>
import AudioPlayerVue from "./AudioPlayer.vue";
import FileUploadMultipleVue from "../common/FileUploadMultiple";

export default {
  props: ["d"],
  components: {
    "audio-player": AudioPlayerVue,
    "file-upload-multiple": FileUploadMultipleVue,
  },
  data() {
    return {
      diagnosis: "",
      img: "",
      imgName: "",
      invsts: [],
      pflag: true,
      loading: false,
      imgUrl: null,
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
    };
  },
  methods: {
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
      _self.imgName = uimg.filename;
      _self.invsts = uimg.filename.split(".")[1] || null;
      _self.bio_att.push({
        name: uimg.filename,
        url: uimg.url,
      });
    },
  },
};
</script>